import React from 'react'
import './Hero.scss'
// import duicon from './assets/duicon.png'
import config from '../../../Config'
// import LogoStack from '../../../components/LogoStack/LogoStack'

function Hero() {

    // const switchTheme = () => {
    //     const root = document.documentElement
    //     const isDark = root.classList.contains('dark')
    //     const newTheme = isDark ? 'light' : 'dark'
    //     root.classList.remove(isDark ? 'dark' : 'light')
    //     root.classList.add(newTheme)
    //     localStorage.setItem('theme', newTheme)
    // }


    return (

        <section className='hero'>

            {/* <OGHeader></OGHeader> */}

            <div className='hero-content-container'>



                <h1 className='huge bigtext'>Designing Intuitive <br /> Interfaces</h1>

                <p className='md hero-subtext'>Hi, I'm Junaid, a senior product designer based in Dubai with 8 years of experience </p>

                {/* <div id='designing-for-container'>
                    <p className='md hero-subtext'> currently designing for</p>

                    <img className='duiconbigbox' src={duicon} alt="Description" id='duiconbigbox' />

                    <a href={config.telecom}>
                        <p className='md  hero-subtext'>telecom</p>
                    </a>

                    <svg width="30" height="30" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">


                        <g clip-path="url(#clip0)">

                            <path
                                d="M22.4092 6.92041L6.591 22.0795"
                                stroke="var(--color-gray-600)"
                                stroke-width="2.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />

                            <path
                                d="M22.4092 20.7613V6.92041H7.90918"
                                stroke="var(--color-gray-600)"
                                stroke-width="2.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />

                        </g>


                        <defs>
                            <clipPath id="clip0">
                                <rect width="29" height="29" fill="white" transform="translate(29) rotate(90)" />
                            </clipPath>
                        </defs>
                    </svg>


                </div> */}


                <div className='hero-button-container'>

                    <button onClick={() => window.open(config.resumeLink, '_blank')}>View Resume</button>

                    {/* <button className='secondary' onClick={switchTheme}> View  Linkedin</button> */}

                    <button className='secondary' onClick={() => window.open(config.linkedinLink, '_blank')} > View  Linkedin</button>

                </div>

                {/* <LogoStack></LogoStack> */}


            </div>





        </section>

    )
}

export default Hero